import { FC, MouseEventHandler } from "react";
import { WhiteButton } from "./style";

export interface SignInGovBrButtonPropsWhite {
  onClick?: (() => void) | MouseEventHandler<HTMLButtonElement>;
}

export const SignInGovBrButtonWhite: FC<SignInGovBrButtonPropsWhite> = ({
  onClick,
}) => (
  <WhiteButton type="button" onClick={onClick}>
    <span>Entrar com&nbsp;</span>
    <span style={{ fontWeight: 700 }}>gov.br</span>
  </WhiteButton>
);
